import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { Link } from 'react-router-dom';
import { withNamespaces } from 'react-i18next';
import moment from 'moment';
import { DATE_FORMAT_VERBOSE } from 'constants/config';
import {
  getReportCampaigns,
} from 'redux/actions/reportActions';
import Table from 'components/tables';
import TableHead from 'components/tables/tableHead';
import TableBody from 'components/tables/tableBody';
import TableCell from 'components/tables/tableCell';
import TableRow from 'components/tables/tableRow';
import NoResults from 'components/NoResults';
import Pagination from 'components/pagination/Pagination';
import { getTimezoneAndUTCOffset, prepareFilterParams, formatNumber } from 'utils/report';
import { formatStat } from 'utils/misc';
import {
  campaignDetailUrl,
} from 'constants/routing';

/* eslint-disable react/prop-types */

const CampaignSummaryTab = (props) => {
  let filterParams = {
    ...prepareFilterParams(props.dashboardParams),
    ...getTimezoneAndUTCOffset(),
  };

  useEffect(() => {
    if (props.isMocked) {
      return;
    }
    filterParams = {
      ...prepareFilterParams(props.dashboardParams),
      ...getTimezoneAndUTCOffset(),
    };
    props.getReportCampaigns(filterParams);
  }, [props.dashboardParams]);

  const renderCampaignSummary = row => (
    <TableRow>
      <TableCell>
        <Link to={campaignDetailUrl(row.id)}>
          {row.name}
        </Link>
      </TableCell>
      <TableCell>{row.launch_date
        ? moment(row.launch_date).format(DATE_FORMAT_VERBOSE) : 'N/A'}
      </TableCell>
      <TableCell alignRight>{parseInt(row.completed * 100, 10)}%</TableCell>
      <TableCell alignRight>{formatStat(row.people_contacted, row.interested)}</TableCell>
      <TableCell alignRight>{formatStat(row.people_contacted, row.expanded_interest)}</TableCell>
      <TableCell alignRight>{formatStat(row.people_contacted, row.opened)}</TableCell>
      <TableCell alignRight>{!Number.isNaN(parseInt(row.potential_reach, 10)) ?
        formatNumber(parseInt(row.potential_reach, 10)) : 'N/A'}
      </TableCell>
    </TableRow>
  );

  const { campaigns } = props.report;

  return (
    <div className="mb-4 overflow-auto">
      {(!campaigns.loading && campaigns.results.length >= 1) &&
        <>
          <Table className="volt-table" noRadius>
            <TableHead>
              <TableRow>
                <TableCell>Campaign name</TableCell>
                <TableCell>Launch Date</TableCell>
                <TableCell alignRight>% Complete</TableCell>
                <TableCell alignRight>Interested</TableCell>
                <TableCell alignRight>Expanded Interest</TableCell>
                <TableCell alignRight>Opened</TableCell>
                <TableCell alignRight>Potential reach</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {campaigns.results.length > 0 &&
                campaigns.results.map(campaign => renderCampaignSummary(campaign))
              }
            </TableBody>
          </Table>

          <Pagination
            items={campaigns}
            onChangePage={props.getReportCampaigns}
            params={filterParams}
          />
        </>
      }

      <NoResults
        loading={campaigns.loading}
        results={campaigns.results}
      />
    </div>
  );
};

export default compose(connect(
  state => ({
    isMocked: state.dashboard.isMocked,
    dashboard: state.dashboard,
    report: state.dashboard.isMocked ? state.dashboard : state.report,
    dashboardParams: state.dashboard.dashboardParams,
  }),
  { getReportCampaigns },
), withNamespaces('common'))(CampaignSummaryTab);
